// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2DJbw","header":"PatientBlock_header__2fhcP","label":"PatientBlock_label__3kxB5","option":"PatientBlock_option__2_qdp"};